<template>
    <highcharts :options="chartOptions"></highcharts>
</template>

<script>
  export default {
    name: 'SeasonWeekChart',
    props: ['season', 'weeks'],
    data () {
      return {
        chartOptions: {
          chart: {
            zoomType: 'xy'
          },
          title: {
            text: 'Player Counts and Hot Rounds'
          },
          xAxis: [{
            categories: [],
            crosshair: true
          }],
          yAxis: [
            { // Primary yAxis
              title: {
                text: 'Hot Round'
              },
              labels: {
                format: '-{value}',
              },
              allowDecimals: false,
              opposite: true
            },
            { // Secondary yAxis
              title: {
                text: 'Players',
              },
              allowDecimals: false
            }
          ],
          tooltip: {
            shared: true
          },
          // legend: {
          //   layout: 'vertical',
          //   align: 'left',
          //   x: 120,
          //   verticalAlign: 'top',
          //   y: 100,
          //   floating: true,
          //   backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || 'rgba(255,255,255,0.25)'
          // },
          series: []
        }
      }
    },
    methods: {
      updateChartData () {
        let chartData = {
          categories: [],
          series: [
            {
              name: 'Players',
              type: 'column',
              yAxis: 1,
              data: []
            },
            {
              name: 'Hot Round',
              type: 'spline',
              data: [],
              tooltip: {
                valuePrefix: '-'
              }
            }
          ]
        };

        const allWeeks = this.weeks.sort((l,r) => {
          if (l.week_date === r.week_date) return 0;
          return l.week_date > r.week_date ? 1 : -1;
        }).map(w => w.week);

        while (allWeeks.length !== 19) {

          let previousWeek = allWeeks[allWeeks.length - 1];
          // correct for bye week
          previousWeek = previousWeek !== 0 ? previousWeek : allWeeks[allWeeks.length - 2];

          allWeeks.push(previousWeek + 1);
        }

        chartData = allWeeks.reduce((result, week) => {
          let item = this.weeks.find(w => w.week === week);

          // fill in missing weeks
          item = item || {
            week,
            player_count: 0,
            hot_round_from_par: 0
          };

          // Add to chart
          result.categories.push((item.week === 0 ? 'Bye Week' : 'Week ' + item.week));
          result.series[0].data.push(parseInt(item.player_count));
          result.series[1].data.push(Math.abs(parseInt(item.hot_round_from_par)));
          return result;
        }, chartData);

        this.chartOptions.series =  chartData.series;
        this.chartOptions.xAxis[0].categories = chartData.categories;

      }
    },
    watch: {
      'player': 'updateChartData'
    },
    created () {
      this.updateChartData()
    }
  }

  /*


   */
</script>

<style scoped>

</style>
